import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'hello',
      meta:{title:"欢迎"},
      component: resolve => require(['@/components/HelloWorld'], resolve),
    },
    {
      path: '/uploadWork',
      name: 'upload',
      meta:{title:"上传项目文件"},
      component: resolve => require(['@/page/reportWork'], resolve),
    },
    {
      path: '/device',
      name: 'device',
      meta:{title:"设备程序上传"},
      component: resolve => require(['@/page/device'], resolve),
    },
    {
      path: '/handbook',
      name: 'handbook',
      meta:{title:"调试手册上传"},
      component: resolve => require(['@/page/handbook'], resolve),
    },
    {
      path: '/specification',
      name: 'specification',
      meta:{title:"说明书上传"},
      component: resolve => require(['@/page/specification'], resolve),
    },
    {
      path: '/software',
      name: 'software',
      meta:{title:"调试工具上传"},
      component: resolve => require(['@/page/software'], resolve),
    },
    {
      path: '/certificate',
      name: 'certificate',
      meta:{title:"证书上传"},
      component: resolve => require(['@/page/certificate'], resolve),
    },
    {
      path: '/uploadFile',
      name: 'uploadFile',
      meta:{title:"文件上传"},
      component: resolve => require(['@/page/UploadFile'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js